import { View } from 'react-native';
import { Layout } from '@ui-kitten/components';

import ScreenSize from '../../../Helper/ScreenSize';
import ThemeColor from '../../../Theme/colors';

const ListGroupSection = ({
  sections,
  renderSectionHeader,
  renderItem,
  onLayout,
}) => {
  const { xs } = ScreenSize();
  return (
    <View
      style={
        !xs && {
          backgroundColor: ThemeColor.white,
          paddingLeft: 20,
          marginHorizontal: 50,
        }
      }
      onLayout={onLayout}
    >
      {typeof renderSectionHeader === 'function' && (
        <Layout>{renderSectionHeader({ section: sections })}</Layout>
      )}
      <Layout>{renderItem({ section: sections })}</Layout>
    </View>
  );
};

export default ListGroupSection;
